import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { Button, Link } from "@/libraries/design/components";
import { wacToken } from "@/libraries/design/foundations";

export interface TemplateCtaProps {
    title: string;
    copy: string;
    buttonHref: string;
    linkHref: string;
}

const containerStyle = css({
    backgroundColor: wacToken("color.extended.blue100"),
    borderRadius: wacToken("corner.radius.card"),
    padding: token("space.400"),
    display: "flex",
    gap: token("space.400"),
    width: "fit-content",

    [media.below.md]: {
        padding: token("space.300")
    },

    [media.below.sm]: {
        flexDirection: "column"
    }
});

const copyContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: token("space.050"),
    justifyContent: "center"
});

const ctaContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: token("space.200"),
    justifyContent: "center",
    alignItems: "center",

    [media.below.sm]: {
        alignItems: "flex-start"
    }
});

const noWrapLinkStyle = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    a: {
        whiteSpace: "nowrap"
    }
});

const marginZeroCss = css({
    marginBlock: token("space.0")
});

export const TemplateCta = (props: TemplateCtaProps) => {
    const intl = useIntl();
    return (
        <div css={containerStyle}>
            <div css={copyContainerStyle}>
                <p className="card-title" css={marginZeroCss}>
                    {props.title}
                </p>
                <p css={marginZeroCss}>{props.copy}</p>
            </div>
            <div css={[ctaContainerStyle, noWrapLinkStyle]}>
                <Button
                    variant="primary"
                    size="small"
                    color="blue"
                    href={props.buttonHref}
                >
                    {intl.formatMessage({
                        id: "template-cta.use-template",
                        defaultMessage: "Use template"
                    })}
                </Button>
                {props.linkHref && (
                    <Link
                        text={intl.formatMessage({
                            id: "template-cta.learn-more",
                            defaultMessage: "Learn more"
                        })}
                        href={props.linkHref}
                    />
                )}
            </div>
        </div>
    );
};
